"use client";

import React, { useEffect } from "react";
import { trackBookingConfirmed } from "@/lib/analytics";

const calLink = process.env.NEXT_PUBLIC_CAL_LINK;

interface CalEmbedProps {
  calLink: string;
}

const CalSchedular: React.FC<CalEmbedProps> = () => {
  useEffect(() => {
    // Define Cal namespace if it doesn't exist
    (function (C: any, A: any, L: any) {
      let p = function (a: any, ar: any) {
        a.q.push(ar);
      };
      let d = C.document;
      C.Cal =
        C.Cal ||
        function () {
          let cal = C.Cal;
          let ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement("script")).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api = function () {
              p(api, arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            if (typeof namespace === "string") {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              return;
            }
            p(cal, ar);
            return;
          }
          p(cal, ar);
        };
    })(window, "https://app.cal.com/embed/embed.js", "init");

    // Initialize Cal.com
    (window as any).Cal("init", { origin: "https://cal.com" });

    // Setup the inline embed
    (window as any).Cal("inline", {
      elementOrSelector: "#cal-booking-place",
      calLink: calLink,
      layout: "month_view",
      primaryColor: "#0070f3",
    });

    // Only a completed booking counts as a conversion; clicking through to this
    // page is tracked separately as schedule_click. bookingSuccessfulV2 carries
    // no attendee name or email, and only the event type id is forwarded on.
    (window as any).Cal("on", {
      action: "bookingSuccessfulV2",
      callback: (e: any) => {
        trackBookingConfirmed({ eventTypeId: e?.detail?.data?.eventTypeId });
      },
    });
  }, []);

  return (
    <div className="w-full mx-auto px-4 mt-8">
      <div id="cal-booking-place" className="min-h-[600px] w-full"></div>
    </div>
  );
};

export default CalSchedular;
